import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/account/bids", key: "acct.myBids", testid: "account-tab-bids" },
  { to: "/account/won", key: "acct.won", testid: "account-tab-won" },
  { to: "/account", key: "acct.favorites", testid: "account-tab-favorites", end: true },
  { to: "/account/horses", key: "acct.followedHorses", testid: "account-tab-horses" },
  { to: "/account/submissions", key: "acct.submissions", testid: "account-tab-submissions" },
  { to: "/account/notifications", key: "acct.alerts", testid: "account-tab-notifications" },
  { to: "/account/settings", key: "acct.profile", testid: "account-tab-settings" },
  { to: "/account/payments", key: "acct.payments", testid: "account-tab-payments" },
];

/** Lightweight buyer account area — lives in the PUBLIC shell, never the dashboard. */
export const AccountLayout = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-14 lg:py-20" data-testid="account-page">
      <h1 className="text-4xl sm:text-5xl font-light tracking-tighter text-[#0A0A0A]">{t("acct.title")}</h1>
      <div className="relative mt-10">
        <nav className="flex items-center gap-1 border-b border-black/5 overflow-x-auto" aria-label={t("acct.title")}>
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              data-testid={tab.testid}
              className={({ isActive }) =>
                `px-4 py-3 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors duration-200 ${
                  isActive ? "border-[#1D4D3B] text-[#0A0A0A]" : "border-transparent text-[#0A0A0A]/50 hover:text-[#0A0A0A]"
                }`
              }
            >
              {t(tab.key)}
            </NavLink>
          ))}
        </nav>
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-white to-transparent sm:hidden" />
      </div>
      <div className="mt-10">{children}</div>
    </div>
  );
};
